// extracted by mini-css-extract-plugin
module.exports = {"departments":"OQ","departmentHeading":"PQ","departmentSection":"QQ","departmentName":"RQ","departmentLink":"SQ","expandIcon":"TQ"};